module.exports = __webpack_public_path__ + "img/calendar-days-solid.324d6120.svg";